<template>
    <!-- Wallet Card -->
    <div class="section pt-1">
        <div class="wallet-card">
            <!-- Balance -->
            <div class="balance">
                <div class="left">
                    <span class="title">{{ $route.params.exam }} Registration</span>
                    <h1 class="total text-primary">{{ member_lists.total }}</h1>
                    <span class="text-danger">Fees Collected : {{admin_fees_amount.toFixed(2)}}</span>
                </div>
                <div class="right">
                    <a href="javascript:void(0);" class="button" @click="adminAdd">
                        <ion-icon name="add-outline"></ion-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">{{ $route.params.exam }} രജിസ്റ്റർ ചെയ്തവരുടെ ലിസ്റ്റ്</h3>
        </div>
    </div>
    <div class="section text-primary" v-if="permissions.result_download">
        <span><a :href="download" :download="'Result'">
                <ion-icon name="download-outline"></ion-icon> Download Result
            </a></span>
    </div>
    <!-- attendanceModel -->
    <div class="modal fade action-sheet" id="addPaymentModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Payment</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>Amount</span></label>
                                <input name="payment_amount" :disabled="true" type="text" class="form-control"
                                    v-model="payment_amount" placeholder="Amount" autocomplete="off" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>Payment Status</span></label>
                                <select as="select" class="form-control custom-select" v-model="payment_status"
                                    name="payment_status" id="select4">
                                    <option value>---Status---</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Paid">Paid</option>
                                </select>
                            </div>
                            <input type="hidden" v-model="member_id" />
                        </div>

                        <div class="form-group basic">
                            <button type="button" @click="savePayment()" class="btn btn-primary btn-block btn-lg"
                                :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>Save</span></button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Exam Center Modal (QHLS admin assign) -->
    <div class="modal fade action-sheet" id="examCenterModal" tabindex="-1" role="dialog" v-if="$route.params.exam === 'QHLS'">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Exam Center</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content" v-if="examCenterMember">
                        <p class="mb-2"><strong>{{ examCenterMember.name }}</strong></p>
                        <p v-if="examCenterMember.exam_center_name" class="text-primary small mb-2">
                            Current: {{ examCenterMember.exam_center_name }}
                        </p>
                        <p v-else-if="adminCenterMode === 'local'" class="text-muted small mb-2">No center selected yet</p>

                        <div class="form-group basic">
                            <label class="label">Center type</label>
                            <select class="form-control custom-select" v-model="adminCenterMode" @change="onAdminCenterModeChange">
                                <option value="local">Kerala — zone exam center</option>
                                <option value="foreign">Abroad — country (UAE, Saudi Arabia, …)</option>
                            </select>
                        </div>

                        <div v-if="adminCenterMode === 'foreign'" class="form-group basic">
                            <label class="label mal-text">രാജ്യം (Country) *</label>
                            <select class="form-control custom-select" v-model="adminSelectedForeignCountry">
                                <option value="">--- Select Country ---</option>
                                <option v-for="c in foreignCountryOptions" :key="c" :value="c">{{ c }}</option>
                            </select>
                            <p v-if="examCenterMember.is_foreign && examCenterMember.foreign_country" class="text-muted small mt-1">
                                Registered from: {{ examCenterMember.foreign_country }}
                            </p>
                        </div>

                        <div v-else>
                            <p class="text-muted small mb-2">Select district and zone to choose a center (any zone in Kerala).</p>
                            <div class="exam-center-location-filters">
                                <div class="form-group basic mb-2">
                                    <label class="label">District</label>
                                    <select
                                        class="form-control custom-select"
                                        v-model="adminSelectedDistrictId"
                                        :disabled="loadingExamCenters || loadingExamCenterZones"
                                        @change="onAdminDistrictChange"
                                    >
                                        <option value="">-- Select district --</option>
                                        <option v-for="d in examCenterDistricts" :key="d.id" :value="String(d.id)">{{ d.name }}</option>
                                    </select>
                                </div>
                                <div class="form-group basic mb-2">
                                    <label class="label">Zone</label>
                                    <select
                                        class="form-control custom-select"
                                        v-model="adminSelectedZoneId"
                                        :disabled="!adminSelectedDistrictId || loadingExamCenterZones || loadingExamCenters"
                                        @change="onAdminZoneChange"
                                    >
                                        <option value="">-- Select zone --</option>
                                        <option v-for="z in examCenterZones" :key="z.id" :value="String(z.id)">{{ z.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <p v-if="loadingExamCenters || loadingExamCenterZones" class="text-muted small">Loading...</p>
                            <p v-else-if="adminSelectedDistrictId && !adminSelectedZoneId" class="text-muted small">Select a zone to see centers.</p>
                            <p v-else-if="adminSelectedZoneId && zoneExamCenters.length === 0" class="text-muted small">No exam centers found for this zone.</p>
                            <div v-else-if="zoneExamCenters.length > 0" class="exam-center-list">
                                <label
                                    v-for="c in zoneExamCenters"
                                    :key="c.id"
                                    class="exam-center-item"
                                    :class="{ 'exam-center-item--selected': String(adminSelectedExamCenterId) === String(c.id) }"
                                >
                                    <input
                                        type="radio"
                                        class="exam-center-radio"
                                        :value="String(c.id)"
                                        v-model="adminSelectedExamCenterId"
                                    />
                                    <div class="exam-center-info">
                                        <div class="exam-center-name">{{ c.madrasa_name || c.name }}</div>
                                        <div class="exam-center-meta" v-if="c.convenor_name">Convenor: {{ c.convenor_name }}</div>
                                        <div class="exam-center-meta" v-if="c.convenor_phone">Phone: {{ c.convenor_phone }}</div>
                                        <div class="exam-center-meta" v-if="c.exam_start_time && c.exam_end_time">
                                            Time: {{ c.exam_start_time }} - {{ c.exam_end_time }}
                                        </div>
                                        <div class="exam-center-meta" v-else-if="c.exam_time">Time: {{ c.exam_time }}</div>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="form-group basic mt-3">
                            <button type="button" @click="saveAdminExamCenter()" class="btn btn-primary btn-block btn-lg"
                                :disabled="savingExamCenter || (adminCenterMode === 'local' && !adminSelectedExamCenterId) || (adminCenterMode === 'foreign' && !adminSelectedForeignCountry)">
                                <span v-show="savingExamCenter" class="spinner-border spinner-border-sm"></span>
                                <span>Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- AddAdminModel -->
    <div class="modal fade action-sheet" id="addAdminModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_admin">Edit</h5>
                    <h5 class="modal-title" v-if="add_admin">Add New</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAdmin" :validation-schema="schema">
                            <!-- <div class="form-group basic">
                                <label class="label" for="stay"><span>നിലവിൽ മെമ്പർ ആണോ</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <select as="select" class="form-control custom-select" v-model="isMember"
                                            name="isMember" id="select4">
                                            <option value="Y">അതെ</option>
                                            <option value="N">അല്ല</option>
                                        </select>
                                    </div>
                                    <input type="hidden" v-model="member_id" />
                                </div>
                            </div> -->
                            <div class="form-group row boxed typehead-div" v-if="isMember == 'Y'">
                                <div class="input-wrapper col-12">
                                    <label class="label" for="text4b">Member</label>
                                    <v-select label="text" :filterable="true" v-model="member" :value="member"
                                        :options="member_list" @input="getTextList($event.target.value, 0)">
                                        <template>
                                            type to search...
                                        </template>
                                        <template>
                                            <div class="d-center">
                                                {{ member.name }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <ErrorMessage name="member" class="error-feedback" />
                                </div>
                                <div class="input-info" v-if="member">Mobile :{{ member.country_code }} {{
                                    member.mobile
                                }}
                                </div>
                            </div>
                            <div class="form-group basic" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <label class="label" for="name"><span>Name</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <div class="form-group boxed">
                                            <Field name="name" type="text" class="form-control" v-model="name"
                                                :disabled="disable_member_form" placeholder="Name" autocomplete="off" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group basic" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <label class="label" for="mobile"><span>Mobile Number</span></label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <div class="form-group boxed">
                                            <Field name="mobile" type="text" class="form-control"
                                                :disabled="disable_member_form" v-model="mobile" placeholder="Mobile"
                                                autocomplete="off" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                                    v-if="permissions.update">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Save</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg" v-if="!permissions.update"
                                    @click="closeAddAdminModel">Close</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- DeleteMemberModel -->

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">ഇതുവരെ ആരെയും
            ചേർത്തിട്ടില്ല</h4>
    </div>
    <!-- <div id="search" v-if="!loading_list">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" placeholder="ഇവിടെ സെർച്ച് ചെയ്യുക..." v-model="search_qty"
                    @input="filteredMembers()">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div> -->
    <!-- <div class="section" v-if="!loading_list">
        <span><a :href="'https://batch.msoftit.com/reports/pdf/reportZonalCouncil.php?zone_id=' + unit.id + '&wing=6&mobile='+currentUser.phone"
                :download="'Girls Zonal Council'">
                <ion-icon name="download-outline"></ion-icon> Download PDF
            </a></span>
    </div> -->
    <ul class="listview image-listview inset text mt-1" v-if="!loading_list && member_lists.total > 0">
        <li v-for="(member_list, index) in member_lists.data" v-bind:key="member_list.id"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ (member_lists.from + index) }}</span>
                <div class="avatar-section">
                    <a href="#">
                        <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                        <span class="button verified" v-if="member_list.payment_status == 'Paid' && permissions.fees">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="button not-verified" v-if="member_list.payment_status == 'Pending' && permissions.fees">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                    </a>
                </div>
                <div class="in">
                    <div class="candidate-info">
                        <div class="candidate-name">{{ member_list.name }}</div>
                        <span
                            class="attempt-badge"
                            :class="hasExamAttempted(member_list) ? 'attempt-badge--yes' : 'attempt-badge--no'"
                        >
                            {{ examAttemptLabel(member_list) }}
                        </span>
                        <div class="candidate-meta">
                            <span class="candidate-phone">{{ member_list.mobile }}</span>
                            <span
                                v-if="$route.params.exam === 'QHLS' && member_list.exam_center_name"
                                class="candidate-center"
                            >
                                Center: {{ member_list.exam_center_name }}
                            </span>
                        </div>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Action</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">

                                        <li>
                                            <a :href="'tel:' + member_list.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> Call
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="permissions.fees">
                                            <a href="javascript:void(0)" @click="adminPayment(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="card-outline"></ion-icon> Payment
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="$route.params.exam === 'QHLS'">
                                            <a href="javascript:void(0)" @click="openExamCenterModal(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="location-outline"></ion-icon> Exam Center
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.receipt_link">
                                            <a :href="member_list.receipt_link" download
                                                class="btn btn-list">
                                                <span>
                                                    <ion-icon name="receipt-outline"></ion-icon> Receipt Download
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)" @click="adminDeleteConfirmation(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> Remove
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> Cancel
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <div class="section mt-2" v-if="!loading_list">
        <vue-awesome-paginate v-if="member_lists.total > 0" :total-items="member_lists.total"
            :items-per-page="member_lists.per_page" :max-pages-shown="3" v-model="member_lists.current_page"
            :on-click="getMembersList" :show-ending-buttons="true" :show-breakpoint-buttons="false" />
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import UserService from "../../services/user.service";
import vSelect from 'vue-select'
import $ from 'jquery';
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
export default {
    name: 'Admin List',
    components: {
        Form,
        Field,
        vSelect,
        ErrorMessage,
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            member: [],
            member_edit: true,
            orgnal_member_lists: [],
            trash_list: [],
            unit: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            attendance: 'A',
            attendance_remarks: '',
            search_qty: '',
            member_id: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            filter_wing: '',
            isMember: 'Y',
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            isEdit: false,
            sub_level_name: '',
            download: '',
            payment_amount: '',
            payment_status: '',
            admin_fees_amount: 0,
            latest_exam: '',
            examCenterMember: null,
            zoneExamCenters: [],
            adminSelectedExamCenterId: '',
            adminSelectedForeignCountry: '',
            savingExamCenter: false,
            loadingExamCenters: false,
            foreignCountryOptions: ['UAE', 'Saudi Arabia', 'Qatar', 'Bahrain', 'Oman'],
            adminCenterMode: 'local',
            examCenterDistricts: [],
            examCenterZones: [],
            adminSelectedDistrictId: '',
            adminSelectedZoneId: '',
            loadingExamCenterZones: false,

        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        minusToZero() {
            let value = this.unit.nerpatham_target - this.member_lists.total;
            if (value <= 0) {
                return '0';
            } else {
                return value;
            }
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.getMembersList(1);
            this.$root.updateParent('Loading...');
        }
        this.getComboboxValues('COUNTRY_CODE');
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'COUNTRY_CODE':
                            this.country_code_list = response.data.data.list.options;
                            break;
                        case 'UNVERIFIED_REASON':
                            this.verification_status_list = response.data.data.list.options;
                            break;

                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                unit_id: this.$route.params.id,
                user_level: this.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminView(admin) {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.isEdit = true;
            if (admin.member_id) {
                this.member_id = admin.member_id;
                this.disable_member_form = true;
            } else {
                this.disable_member_form = false;
            }
            if (admin.remarks == 'renew') {
                this.isSubscriber = true;
            }
            this.name = admin.name;
            this.mobile = admin.mobile;
            this.subscription_no = admin.subscription_no;
            this.receipt_no = admin.reciept_no;
            this.member_edit = false;
            this.member_list.push(this.member);
            this.designation = admin.designation;
            this.editable_id = admin.id;
            this.add_admin = false;
            this.edit_admin = true;
        },
        adminPayment(member) {
            this.member_id = member.id;
            this.payment_status = member.payment_status;
            // this.payment_amount = member.payment_amount;
            $('#addPaymentModel').modal('show');
        },
        adminAdd() {
            $('#addAdminModel').modal('show');
            this.disable_member_form = false;
            this.message = '';
            this.member_id = '';
            this.name = '';
            this.mobile = '';
            this.subscription_no = '';
            this.receipt_no = '';
            this.member_edit = true;
            this.member = '';
            this.editable_id = null;
            this.add_admin = true;
            this.edit_admin = false;
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        addAdmin(user) {
            console.log(user);
            user.editable_id = this.editable_id;
            user.is_member = this.isMember;
            user.isSubscriber = this.isSubscriber;
            if (!this.member && this.isMember == 'Y') {
                this.message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക';
            }
            if (this.member) {
                user.member_id = this.member.id;
            }
            user.event_type = this.$route.params.exam;
            user.unit_id = parseInt(this.$route.params.id);
            UserService.addAdmin('store-qhls', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1, 6);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        adminDelete(data) {
            UserService.authPostRequest('delete-qhls', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1, 6);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getWing(wing) {
            if (wing == 1)
                return 'വിസ്‌ഡം';
            else if (wing == 2)
                return 'യൂത്ത്';
            else if (wing == 3)
                return 'സ്റ്റുഡന്റസ്';
            else if (wing == 4)
                return 'വിമെൻ';
            else
                return 'ഗേൾസ്';
        },
        getMembersList(page = 1) {
            this.loading_list = true;
            let data = {
                user_level: this.user_level,
                unit_id: parseInt(this.$route.params.id),
                event_type: this.$route.params.exam
            }
            UserService.authPostRequest(`get-qhls-registrations?page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.latest_exam = response.data.data.latest_exam;
                        this.payment_amount = response.data.data.fees_amount;
                        this.admin_fees_amount = response.data.data.admin_fees_amount;
                        this.permissions = response.data.data.permissions;
                        this.download = response.data.data.result_download_url;
                        this.member_lists = response.data.data.list;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list.data;
                        this.unit = response.data.data.unit;
                        this.$root.updateParent(this.$route.params.exam + ' Registration ' + response.data.data.unit.name);
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        showActionModel() {
            this.pin_number = '';
        },
        openExamCenterModal(member) {
            this.examCenterMember = member;
            this.adminSelectedExamCenterId = member.qhls_exam_center_id ? String(member.qhls_exam_center_id) : '';
            this.adminSelectedForeignCountry = member.foreign_country || '';
            const centerName = member.exam_center_name || '';
            const isForeignCenter = this.foreignCountryOptions.includes(centerName);
            this.adminCenterMode = (member.is_foreign || isForeignCenter || member.foreign_country) ? 'foreign' : 'local';
            if (this.adminCenterMode === 'foreign' && !this.adminSelectedForeignCountry) {
                this.adminSelectedForeignCountry = member.foreign_country || (isForeignCenter ? centerName : '');
            }
            this.adminSelectedDistrictId = '';
            this.adminSelectedZoneId = '';
            this.examCenterZones = [];
            this.zoneExamCenters = [];
            if (this.adminCenterMode === 'local') {
                this.loadAdminExamCenterPicker(member);
            }
            $('#examCenterModal').modal('show');
        },
        onAdminCenterModeChange() {
            this.adminSelectedExamCenterId = '';
            this.adminSelectedForeignCountry = '';
            this.adminSelectedDistrictId = '';
            this.adminSelectedZoneId = '';
            this.examCenterZones = [];
            this.zoneExamCenters = [];
            if (this.adminCenterMode === 'local') {
                this.loadAdminExamCenterPicker(this.examCenterMember);
            }
        },
        fetchExamCenterDistricts() {
            return UserService.authPostRequest('get-district-by-id', {})
                .then((res) => {
                    if (res.data && res.data.status === 'success') {
                        const list = res.data.data && res.data.data.list;
                        this.examCenterDistricts = Array.isArray(list) ? list : (list ? [list] : []);
                    } else {
                        this.examCenterDistricts = [];
                    }
                })
                .catch(() => {
                    this.examCenterDistricts = [];
                });
        },
        fetchExamCenterZones(districtId) {
            this.loadingExamCenterZones = true;
            this.examCenterZones = [];
            if (!districtId) {
                this.loadingExamCenterZones = false;
                return Promise.resolve();
            }
            return UserService.authPostRequest('get-zone-by-id', { district_id: districtId })
                .then((res) => {
                    if (res.data && res.data.status === 'success') {
                        const list = res.data.data && res.data.data.list;
                        this.examCenterZones = Array.isArray(list) ? list : (list ? [list] : []);
                    } else {
                        this.examCenterZones = [];
                    }
                })
                .catch(() => {
                    this.examCenterZones = [];
                })
                .finally(() => {
                    this.loadingExamCenterZones = false;
                });
        },
        onAdminDistrictChange() {
            this.adminSelectedZoneId = '';
            this.adminSelectedExamCenterId = '';
            this.zoneExamCenters = [];
            this.fetchExamCenterZones(this.adminSelectedDistrictId);
        },
        onAdminZoneChange() {
            this.adminSelectedExamCenterId = '';
            this.fetchAdminZoneExamCenters();
        },
        fetchExamCenterDetailById(centerId) {
            if (!centerId) {
                return Promise.resolve(null);
            }
            return UserService.authGetRequest('qhls-exam-centers', { center_id: centerId })
                .then((res) => {
                    const list = res.data?.data?.list;
                    return Array.isArray(list) && list.length > 0 ? list[0] : null;
                })
                .catch(() => null);
        },
        applyAdminExamCenterLocation(center) {
            if (!center) {
                return Promise.resolve();
            }
            const applyWithIds = (districtId, zoneId) => {
                const dId = districtId ? String(districtId) : '';
                const zId = zoneId ? String(zoneId) : '';
                if (!dId && !zId) {
                    return Promise.resolve();
                }
                const loadZones = () => {
                    if (!dId) {
                        if (zId) {
                            this.adminSelectedZoneId = zId;
                            return this.fetchAdminZoneExamCenters();
                        }
                        return Promise.resolve();
                    }
                    this.adminSelectedDistrictId = dId;
                    return this.fetchExamCenterZones(dId).then(() => {
                        if (zId) {
                            this.adminSelectedZoneId = zId;
                            return this.fetchAdminZoneExamCenters();
                        }
                    });
                };
                if (!this.examCenterDistricts.length) {
                    return this.fetchExamCenterDistricts().then(loadZones);
                }
                return loadZones();
            };
            let districtId = center.district_id || '';
            const zoneId = center.zone_id || '';
            if (!districtId && zoneId) {
                return UserService.authPostRequest('get-zone-by-id', { id: zoneId })
                    .then((res) => {
                        const list = res.data?.data?.list;
                        const zone = Array.isArray(list) ? list[0] : list;
                        districtId = zone && zone.district_id ? zone.district_id : '';
                    })
                    .catch(() => {})
                    .then(() => applyWithIds(districtId, zoneId));
            }
            return applyWithIds(districtId, zoneId);
        },
        initAdminLocationFromUnit() {
            const districtId = this.unit && this.unit.district_id
                ? String(this.unit.district_id)
                : (this.currentUser && this.currentUser.district_id ? String(this.currentUser.district_id) : '');
            const zoneId = this.unit && this.unit.zone_id
                ? String(this.unit.zone_id)
                : (this.currentUser && this.currentUser.zone_id ? String(this.currentUser.zone_id) : '');
            if (!districtId) {
                return Promise.resolve();
            }
            this.adminSelectedDistrictId = districtId;
            return this.fetchExamCenterZones(districtId).then(() => {
                if (zoneId) {
                    this.adminSelectedZoneId = zoneId;
                    return this.fetchAdminZoneExamCenters();
                }
            });
        },
        loadAdminExamCenterPicker(member) {
            const init = () => {
                const centerId = member && member.qhls_exam_center_id ? String(member.qhls_exam_center_id) : '';
                if (centerId) {
                    const ec = member.exam_center;
                    if (ec && String(ec.id) === centerId) {
                        return this.applyAdminExamCenterLocation(ec);
                    }
                    return this.fetchExamCenterDetailById(centerId).then((center) => {
                        if (center) {
                            return this.applyAdminExamCenterLocation(center);
                        }
                        return this.initAdminLocationFromUnit();
                    });
                }
                return this.initAdminLocationFromUnit();
            };
            if (!this.examCenterDistricts.length) {
                return this.fetchExamCenterDistricts().then(init);
            }
            return init();
        },
        fetchAdminZoneExamCenters() {
            const zoneId = this.adminSelectedZoneId;
            if (!zoneId) {
                this.zoneExamCenters = [];
                return Promise.resolve();
            }
            this.loadingExamCenters = true;
            return UserService.authGetRequest('qhls-exam-centers', { zone_id: zoneId })
                .then((res) => {
                    if (res.data.status === 'success' && Array.isArray(res.data.data?.list)) {
                        this.zoneExamCenters = res.data.data.list;
                        const selectedId = this.adminSelectedExamCenterId;
                        if (selectedId && !this.zoneExamCenters.some((c) => String(c.id) === String(selectedId))) {
                            const ec = this.examCenterMember && this.examCenterMember.exam_center;
                            if (ec && String(ec.id) === String(selectedId)) {
                                this.zoneExamCenters = [...this.zoneExamCenters, ec];
                            }
                        }
                    } else {
                        this.zoneExamCenters = [];
                    }
                })
                .catch(() => {
                    this.zoneExamCenters = [];
                })
                .finally(() => {
                    this.loadingExamCenters = false;
                });
        },
        saveAdminExamCenter() {
            if (!this.examCenterMember) return;
            const data = {
                registration_id: this.examCenterMember.id,
                unit_id: (this.unit && this.unit.id) ? parseInt(this.unit.id, 10) : parseInt(this.$route.params.id, 10),
                exam_type: this.$route.params.exam,
            };
            if (this.adminCenterMode === 'foreign') {
                data.foreign_country = this.adminSelectedForeignCountry;
            } else {
                data.exam_center_id = this.adminSelectedExamCenterId;
            }
            this.savingExamCenter = true;
            UserService.authPostRequest('admin-assign-qhls-exam-center', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        $('#examCenterModal').modal('hide');
                        this.getMembersList(this.member_lists.current_page || 1);
                    } else {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message || 'Save failed';
                        this.$refs.alert_model.openModel();
                    }
                    this.savingExamCenter = false;
                },
                (error) => {
                    this.savingExamCenter = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || 'Save failed';
                    this.$refs.alert_model.openModel();
                }
            );
        },
        attendanceOpen(member) {
            this.member_id = member.id;
            this.attendance = member.attendance.attendance != 'N' ? member.attendance.attendance : 'A';
            this.attendance_remarks = member.attendance.leave_reason;
            $('#attendanceModel').modal('show');
        },
        savePayment() {
            let data = {
                id: this.member_id,
                payment_status: this.payment_status,
                payment_amount: this.payment_amount
            }
            this.loading = true;
            UserService.authPostRequest('save-exam-payment', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(this.member_lists.current_page);
                        $('#addPaymentModel').modal('hide');
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );

        },
        hasExamAttempted(member) {
            if (!member) {
                return false;
            }
            if (member.exam_attempted === true || member.exam_attempted === 1 || member.exam_attempted === '1') {
                return true;
            }
            if (member.exam_attempted === false || member.exam_attempted === 0 || member.exam_attempted === '0') {
                return false;
            }
            if (member.exam_status) {
                const status = String(member.exam_status);
                return status.includes('എഴുതി') && !status.includes('എഴുതിയില്ല');
            }
            if (this.latest_exam != null && this.latest_exam !== '' && member.latest_exam != null && member.latest_exam !== '') {
                return String(this.latest_exam) === String(member.latest_exam);
            }
            return false;
        },
        examAttemptLabel(member) {
            if (member && member.exam_status) {
                return member.exam_status;
            }
            return this.hasExamAttempted(member) ? 'പരീക്ഷ എഴുതി' : 'പരീക്ഷ എഴുതിയില്ല';
        },
        filteredMembers() {
            // this.loading_list = true;
            // let filter_list = this.orgnal_member_lists;
            // filter_list = filter_list.filter((samsung) => {
            //     return this.search_qty.toLowerCase().split(' ').every(v => samsung.member.name.toLowerCase().includes(v)) || this.search_qty.toLowerCase().split(' ').every(v => samsung.member.mobile.toLowerCase().includes(v));
            // });
            // this.member_lists = filter_list;
            this.loading_list = false;
        }
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

/* removed empty .listview ruleset (lint) */

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.listview.image-listview > li .item {
    align-items: flex-start;
    padding-top: 12px;
    padding-bottom: 12px;
}

.listview.image-listview > li .item .in {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex: 1;
    min-width: 0;
    gap: 6px;
}

.candidate-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
}

.candidate-name {
    font-size: 15px;
    font-weight: 700;
    line-height: 1.35;
    color: #1a418c;
    width: 100%;
    word-break: break-word;
}

.candidate-meta {
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 100%;
}

.candidate-phone {
    font-size: 14px;
    font-weight: 500;
    color: #171617;
    line-height: 1.3;
}

.candidate-center {
    font-size: 12px;
    color: #6c757d;
    line-height: 1.35;
    word-break: break-word;
}

.attempt-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 999px;
    line-height: 1.25;
    border: 1px solid transparent;
    white-space: nowrap;
    flex-shrink: 0;
}

.attempt-badge--yes {
    color: #0f5132;
    background: #d1e7dd;
    border-color: #badbcc;
}

.attempt-badge--no {
    color: #664d03;
    background: #fff3cd;
    border-color: #ffecb5;
}

.listview.image-listview > li .card-button {
    flex-shrink: 0;
    align-self: center;
    margin-top: 2px;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.exam-center-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 280px;
    overflow-y: auto;
}

.exam-center-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 0;
}

.exam-center-item--selected {
    border-color: #1a418c;
    background: rgba(26, 65, 140, 0.07);
}

.exam-center-radio {
    margin-top: 4px;
    flex-shrink: 0;
}

.exam-center-name {
    font-weight: 600;
    color: #1a418c;
    font-size: 14px;
}

.exam-center-meta {
    font-size: 12px;
    color: #6c757d;
}

.exam-center-location-filters .label {
    font-size: 13px;
    margin-bottom: 4px;
}
</style>